import React from 'react';
import { Link } from 'react-router-dom';
import './PolicyPages.css';

const ShippingPolicyPage = () => {
    return (
        <div className='policy-page'>
            <div className='policy-hero'>
                <div className='container'>
                    <h1>Shipping Policy (Rahber Corporation, Since 1980)</h1>
                    <p>
                        Showroom Doorstep Delivery Exclusively in Lahore.
                    </p>
                </div>
            </div>

            <div className='container policy-body'>
                <article className='policy-prose'>
                    <p className='lead'>
                        At Rahber Corporation, we provide dedicated showroom doorstep
                        delivery exclusively across Lahore to ensure prompt, safe handling
                        of all major and small home appliances.
                    </p>

                    <h2>1. Lahore Showroom Doorstep Delivery</h2>
                    <p>
                        We offer same-day and scheduled doorstep delivery within Lahore for orders
                        confirmed on call before 5:00 PM on business days (Monday to Saturday).
                    </p>
                    <ul>
                        <li>
                            Orders confirmed after 5:00 PM are dispatched on the next business day.
                        </li>
                        <li>
                            Direct delivery handled by our trained showroom transport crew (covered vans & cargo transport).
                        </li>
                        <li>
                            Appliances are inspected and verified in original factory packing at your doorstep.
                        </li>
                    </ul>

                    <h2>2. Showroom Self-Pickup (Free of Charge)</h2>
                    <p>
                        Customers can also choose direct showroom self-pickup from our Lahore flagship store:
                        <strong> Main Bazar Chandni Chowk, Sanda Kalan, Lahore</strong> during business hours (11:00 AM to 8:00 PM).
                    </p>

                    <h2>3. Order processing</h2>
                    <ul>
                        <li>Orders are processed within 1 to 2 business days.</li>
                        <li>
                            Orders placed on Sundays or public holidays will be
                            processed on the next business day.
                        </li>
                    </ul>

                    <h2>4. Shipping charges</h2>
                    <ul>
                        <li>We maintain transparent pricing.</li>
                        <li>
                            No hidden charges unless clearly mentioned.
                        </li>
                    </ul>

                    <h2>5. Order tracking</h2>
                    <ul>
                        <li>
                            Customers will receive a confirmation call after
                            shipment.
                        </li>
                        <li>
                            Orders can be tracked via the &quot;Track Your
                            Order&quot; section on our website.
                        </li>
                    </ul>

                    <h2>6. Delivery conditions</h2>
                    <ul>
                        <li>
                            Orders are delivered to the exact address provided.
                        </li>
                        <li>
                            For multiple addresses, separate orders must be
                            placed.
                        </li>
                    </ul>

                    <h2>7. Damaged or incorrect items</h2>
                    <ul>
                        <li>Report within 24 hours of delivery.</li>
                        <li>Provide photo or video proof.</li>
                        <li>
                            We will review and provide replacement or solution.
                        </li>
                    </ul>

                    <h2>8. Delays &amp; exceptions</h2>
                    <p>Delays may occur due to:</p>
                    <ul>
                        <li>Weather conditions</li>
                        <li>Courier issues</li>
                        <li>High demand periods</li>
                    </ul>
                    <p>
                        We will always assist you in resolving any delivery
                        issues.
                    </p>

                    <h2>9. Business days</h2>
                    <ul>
                        <li>Monday to Saturday</li>
                        <li>Closed on Sundays and public holidays</li>
                    </ul>

                    <p>
                        Questions? See <Link to='/faq'>FAQ</Link> or{' '}
                        <Link to='/contact'>Contact</Link> us.
                    </p>

                    <p className='policy-meta'>Last updated: April 2026</p>
                </article>
            </div>
        </div>
    );
};

export default ShippingPolicyPage;
